export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/amazon.0d3698f.svg";